import { createBrowserHistory } from 'history'
import React from 'react'
import ReactDOM from 'react-dom'
import { Redirect, Router, Route, Switch } from 'react-router-dom'

import './css/index.css'
import About from './About'
import Connect from './Connect'
import Footer from './Footer'
import Home from './Home'
import HowItWorks from './HowItWorks'
import Invite from './Invite'
import Navbar from './Navbar'
import Overlay from './Overlay'
import PageNotFound from './PageNotFound'
import SubNavbar from './SubNavbar'
import registerServiceWorker from './registerServiceWorker'

const history = createBrowserHistory()

const Routes = props => (
  <Router {...props} history={history}>
    <div>
      <Navbar />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/about" render={() => (
          <div>
            <SubNavbar />
            <div className="bar-blue about-blue" />
            <About />
          </div>
        )} />
        <Route path="/invite" render={() => (
          <div>
            <SubNavbar />
            <Invite />
          </div>
        )} />
        <Route path="/how" render={() => (
          <div>
            <SubNavbar />
            <div className="bar-blue how-blue" />
            <HowItWorks />
          </div>
        )} />
        <Route path="/connect/vendor" render={() => (
          <div>
            <SubNavbar />
            <div className="bar-blue how-blue" />
            <Connect type={'Vendor'} history={history} {...props} />
          </div>
        )} />
        <Route path="/connect/employer" render={() => (
          <div>
            <SubNavbar />
            <div className="bar-blue how-blue" />
            <Connect type={'Employer'} history={history} {...props} />
          </div>
        )} />
        <Route path="/connect/educator" render={() => (
          <div>
            <SubNavbar />
            <div className="bar-blue how-blue" />
            <Connect type={'Educator'} history={history} {...props} />
          </div>
        )} />
        <Route path="/connect" render={() => (
          <div>
            <SubNavbar />
            <div className="bar-blue how-blue" />
            <Connect history={history} {...props} />
          </div>
        )} />
        <Route exact path="/404" render={() => (
          <div>
            <SubNavbar />
            <div className="bar-blue how-blue" />
            <PageNotFound />
          </div>
        )} />
        <Redirect to="/404" />
      </Switch>
      <Overlay />
      <Footer />
    </div>
  </Router>
)

ReactDOM.render(Routes(), document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// src/index.js